module.exports = __webpack_public_path__ + "fonts/unb.c1b4adc0.ttf";